import _ from 'lodash';

// constants
import { getRequest, patchRequest } from '../../Common/network-call';
import { ALLOWED_NOTIFICATION_TYPES } from '../../../constants/section-constants/type-constants';
import { TABLE_URI_ADDON } from '../../../constants/constant';

// actions
import { fetchSessionPolls } from '../../sessions/actions';
import {
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const UPDATE_NOTIFICATION_READ = 'UPDATE_NOTIFICATION_READ';
export const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION';
export const FETCH_NOTIFICATIONS_FOR_APPUSER =
  'FETCH_NOTIFICATIONS_FOR_APPUSER';
export const FETCH_NOTIFICATION_SOCIAL_DETAILS =
  'FETCH_NOTIFICATION_SOCIAL_DETAILS';
export const FETCH_UNREAD_NOTIFICATION_COUNT =
  'FETCH_UNREAD_NOTIFICATION_COUNT';
export const FETCH_NOTIFICATION_COMMUNITY_DETAILS =
  'FETCH_NOTIFICATION_COMMUNITY_DETAILS';
export const FETCH_NOTIFICATION_CHAT_DETAILS =
  'FETCH_NOTIFICATION_CHAT_DETAILS';
export const OPEN_OUTREACH_MODAL = 'OPEN_OUTREACH_MODAL';

// ----- used only for the unread counts, no extra data is fetched here
export const fetchUnreadNotificationCount = (session, callback) => {
  let filter = encodeURI(
      `(eventid=${session.eventid})AND(sentto=${session.userid})AND(isread=0)`
    ),
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.notifications}?include_count=true&fields=${FIELDS.notifications.minInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        dispatch({
          type: FETCH_UNREAD_NOTIFICATION_COUNT,
          payload: {
            count: res.meta.count,
            unread: res.resource.length,
            data: res.resource
          }
        });
        callback({
          success: 1,
          count: res.meta.count,
          unread: res.resource.length,
          data: res.resource
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

// ----- fetches the actual notification data
export const fetchUserNotifications = (session, callback) => {
  let filter = encodeURI(
      `(eventid=${session.eventid})AND(sentto=${session.userid})`
    ),
    order = 'createdon%20DESC',
    related = 'appuser_by_postedbyuserid',
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.notifications}?include_count=true&related=${related}&order=${order}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        let unread = 0;
        if (res.resource.length > 0) {
          _.map(res.resource, notification => {
            if (!notification.isread) unread += 1;
          });
        }

        // --- filer outreach
        let outreachReminderArr = _.filter(
          res.resource,
          item =>
            item?.type === ALLOWED_NOTIFICATION_TYPES.outreach ||
            item?.type === ALLOWED_NOTIFICATION_TYPES.session
        );
        outreachReminderArr.length &&
          _.map(res.resource, notiItem => {
            notiItem.redirect_data = null; // holds redirection data
            notiItem.logo_to_render = notiItem.image; // helps to determine which logo to render

            // other vars
            let filter = '';
            let related = '';
            let url = '';

            if (_.includes(outreachReminderArr, notiItem, 0)) {
              if (notiItem?.type === ALLOWED_NOTIFICATION_TYPES.session) {
                filter = encodeURI(
                  `((sessionid=${notiItem?.associatedid})AND(eventid=${session.eventid}))`
                );
                related = `speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}&interactivemaps_by_interactivemaplocation_session_link.fields=interactivemapid`;
                url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?related=${related}&filter=${filter}`;

                dispatch(
                  fetchOutreachDetails({ session, url }, res => {
                    if (res.success)
                      notiItem.redirect_data = res.data.resource[0];
                  })
                );
              } else if (
                notiItem?.type === ALLOWED_NOTIFICATION_TYPES.outreach &&
                !_.isEmpty(notiItem.redirectto) &&
                !_.isEmpty(notiItem.redirectvalue)
              ) {
                switch (notiItem.redirectto) {
                  case 'poll':
                    filter = encodeURI(
                      `((pollid=${notiItem?.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.pollQuestions}?filter=${filter}&fields=${FIELDS.pollQuestions.minInfo}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success) {
                          let sessionId = res.data.resource[0]?.sessionId;
                          dispatch(
                            fetchSessionPolls(
                              session,
                              { sessionId, pollId: notiItem?.redirectvalue },
                              sessPollRes => {
                                if (sessPollRes?.success)
                                  notiItem.redirect_data =
                                    sessPollRes?.response;
                              }
                            )
                          );
                        }
                      })
                    );
                    break;

                  case 'news':
                    filter = encodeURI(
                      `((newsid=${notiItem?.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.news}?filter=${filter}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];
                      })
                    );
                    break;

                  case 'community':
                    filter = encodeURI(
                      `((communitycategoryid=${notiItem?.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityCategory}?filter=${filter}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];
                      })
                    );
                    break;

                  case 'session':
                    filter = encodeURI(
                      `((sessionid=${notiItem?.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    related = `speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}&interactivemaps_by_interactivemaplocation_session_link.fields=interactivemapid`;
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?related=${related}&filter=${filter}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];
                      })
                    );
                    break;

                  // case 'external':
                  //   break;

                  case 'exhibitor':
                    filter = encodeURI(
                      `((exhibitorid=${notiItem.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    related = 'appuser_by_exhibitoridfk';
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?filter=${filter}&related=${related}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];

                        // which thumbnail/logo to render
                        if (
                          !_.isEmpty(res.data.resource) &&
                          notiItem.logo_to_render == ''
                        ) {
                          if (res.data.resource[0].profileimage != '') {
                            notiItem.logo_to_render =
                              res.data.resource[0]?.profileimage;
                          }
                        }
                      })
                    );
                    break;

                  case 'speaker':
                    filter = encodeURI(
                      `((speakerid=${notiItem.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    related = 'session_by_sessionspeakers';
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}?filter=${filter}&related=${related}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];

                        // which thumbnail/logo to render
                        if (
                          !_.isEmpty(res.data.resource) &&
                          notiItem.logo_to_render == ''
                        ) {
                          if (res.data.resource[0].profileimage != '') {
                            notiItem.logo_to_render =
                              res.data.resource[0]?.profileimage;
                          }
                        }
                      })
                    );
                    break;

                  case 'sponsor':
                    filter = encodeURI(
                      `((sponsorid=${notiItem.redirectvalue})AND(eventid=${session.eventid}))`
                    );
                    related = 'membershiptype_by_categoryid';
                    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}?filter=${filter}&related=${related}`;

                    dispatch(
                      fetchOutreachDetails({ session, url }, res => {
                        if (res.success)
                          notiItem.redirect_data = res.data.resource[0];

                        // which thumbnail/logo to render
                        if (
                          !_.isEmpty(res.data.resource) &&
                          notiItem.logo_to_render == ''
                        ) {
                          if (res.data.resource[0].logoimgpath != '') {
                            notiItem.logo_to_render =
                              res.data.resource[0]?.logoimgpath;
                          }
                        }
                      })
                    );
                    break;

                  default:
                    break;
                }
              }
            }
          });

        dispatch({
          type: FETCH_NOTIFICATIONS_FOR_APPUSER,
          payload: {
            data: res.resource,
            count: res.meta.count,
            unread
          }
        });
        callback({
          success: 1,
          data: res.resource,
          count: res.meta.count,
          unread
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearUserNotifications = () => {
  return dispatch => {
    dispatch({
      type: FETCH_NOTIFICATIONS_FOR_APPUSER,
      payload: {}
    });
  };
};

export const updateNotificationRead = (
  session,
  value,
  refresh = true,
  callback
) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.notifications}/${value.notificationid}`;
  let patchBody = _.omit(value, ['notificationid']);

  return dispatch => {
    patchRequest(
      url,
      patchBody,
      session,
      dispatch,
      updateRes => {
        refresh
          ? dispatch(
              fetchUserNotifications(session, fetchRes => {
                callback({
                  success: 1,
                  updateres: updateRes,
                  fetchres: fetchRes
                });
              })
            )
          : null;
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setSelectedNotification = value => {
  return dispatch => {
    dispatch({ type: SET_SELECTED_NOTIFICATION, payload: value });
  };
};

export const fetchSocialDetails = (session, value, callback) => {
  let filter1 = encodeURI(
    `(eventid=${session.eventid})AND(socialfeedid=${value.id})`
  );
  let related = `appuser_by_postedbyid,appuser_by_socialfeedlikes,appuser_by_socialfeedcomments,socialfeedlikes_by_socialfeedid,socialfeedcomments_by_socialfeedid,socialfeedpollresult_by_socialfeedidfk,appuser_by_socialfeedpollresult&appuser_by_postedbyid.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedlikes.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedcomments.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedpollresult.fields=${FIELDS.appuser.relatedInfo}`;
  let mainUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}?related=${related}&eventid=${session.eventid}}&filter=(${filter1})`;

  return dispatch => {
    getRequest(
      mainUrl,
      session,
      dispatch,
      feedRes => {
        callback({ success: 1 });
        dispatch({
          type: FETCH_NOTIFICATION_SOCIAL_DETAILS,
          payload: {
            type: value.type,
            message: '',
            data: feedRes.resource[0]
          }
        });
      },
      error => {
        dispatch({
          type: FETCH_NOTIFICATION_SOCIAL_DETAILS,
          payload: {
            type: value.type,
            message: 'blank',
            data: []
          }
        });
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearSocialDetails = () => {
  return dispatch =>
    dispatch({ type: FETCH_NOTIFICATION_SOCIAL_DETAILS, payload: {} });
};

export const fetchNotificationCommunityDetails = (session, value, callback) => {
  let filter = encodeURI(
      `(eventid=${session.eventid})AND(communitycategoryid=${value.id})`
    ),
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityCategory}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (res.resource.length > 0) {
          dispatch({
            type: FETCH_NOTIFICATION_COMMUNITY_DETAILS,
            payload: { data: res.resource[0], message: '' }
          });
          callback({ success: 1, data: res.resource[0], message: '' });
        } else {
          dispatch({
            type: FETCH_NOTIFICATION_COMMUNITY_DETAILS,
            payload: { data: res.resource, message: 'blank' }
          });
          callback({ success: 1, data: res.resource, message: 'blank' });
        }
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const fetchNotificationChatDetails = (session, values, callback) => {
  let filter = encodeURI(
      `(eventid=${session.eventid})AND(chatid=${values.chatid})`
    ),
    relatedCall = 'appuser_by_senderid,chatthread_by_chatthreadid',
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chat}?related=${relatedCall}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        dispatch({
          type: FETCH_NOTIFICATION_CHAT_DETAILS,
          payload: res.resource[0]
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

const fetchOutreachDetails = (value, callback) => {
  return dispatch => {
    getRequest(
      value.url,
      value.session,
      dispatch,
      res => {
        callback({ success: 1, data: res });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const openOutreachModal = values => {
  return dispatch => dispatch({ type: OPEN_OUTREACH_MODAL, payload: values });
};
